/**
 * API Configuration
 * Centralized configuration for API endpoints
 */

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://vacspl.in/api';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default API_BASE_URL;
